import React, { useEffect } from 'react'; 
import Navbar from '../Navbar';
import AgentStudioBody from './AgentStudioBody';
import Footer from '../Footer';
import { appInsights } from '../../api/AppInsights';
const AgentStudio = () => {
  useEffect(() => {
        appInsights.trackPageView({ name: 'Agent Studio Page' });
      }, []);
      
  return (
    <>
      <Navbar />
      <AgentStudioBody />
      <Footer />
    </>
  );
};

export default AgentStudio;